import { useEffect } from 'react'
import { AppShell } from './components/AppShell'
import { PublicShell } from './components/PublicShell'
import { DashboardPage } from './pages/DashboardPage'
import { GuidePage, HowItWorksPage, PricingPage, ProjectTypesPage, ResourcesPage } from './pages/PublicPages'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { NewProjectPage } from './pages/NewProjectPage'
import { ProjectPage } from './pages/ProjectPage'
import { PolicyPage } from './pages/PolicyPage'
import { BillingPage } from './pages/BillingPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { QuoteResponsePage } from './pages/QuoteResponsePage'
import { useDemoSession } from './state/demo-session'

function normalizePath(path: string) {
  return path.length > 1 ? path.replace(/\/$/, '') : path
}

export function App() {
  const path = normalizePath(window.location.pathname)
  const session = useDemoSession()

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('demo') === '1' && !session.isAuthenticated) session.enterDemo()
  }, [session])

  if (path.startsWith('/respond/')) return <QuoteResponsePage token={path.slice('/respond/'.length)} />
  if (path === '/login') return <PublicShell><LoginPage session={session} /></PublicShell>

  if (path.startsWith('/app')) {
    if (!session.isAuthenticated) return <PublicShell><LoginPage session={session} heading="Your project room is private." /></PublicShell>
    const content = path === '/app'
      ? <DashboardPage session={session} />
      : path === '/app/billing'
        ? <BillingPage session={session} />
      : path === '/app/projects/new'
        ? <NewProjectPage session={session} />
        : path.startsWith('/app/projects/')
          ? <ProjectPage session={session} />
          : <DashboardPage session={session} />
    return <AppShell session={session}>{content}</AppShell>
  }

  const publicPage = path === '/'
    ? <HomePage />
    : path === '/how-it-works'
      ? <HowItWorksPage />
      : path === '/project-types'
        ? <ProjectTypesPage />
        : path === '/pricing'
          ? <PricingPage />
          : path === '/resources'
            ? <ResourcesPage />
            : ['/roof-replacement', '/hvac-replacement', '/bathroom-remodel'].includes(path)
              ? <GuidePage slug={path.slice(1)} />
              : ['/privacy', '/terms', '/refunds', '/security', '/accessibility', '/contact'].includes(path)
                ? <PolicyPage slug={path.slice(1)} />
                : <NotFoundPage />
  return <PublicShell>{publicPage}</PublicShell>
}
